import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import BackupRoundedIcon from '@mui/icons-material/BackupRounded';
import AttachFileRoundedIcon from '@mui/icons-material/AttachFileRounded';

import Form from './Form';
import graph from './graph';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import { isEmptyObject } from 'helpers/formatObject';
import { Alert, CircularProgress, Typography } from '@mui/material';
import { NewDialog, NewDialogActions, NewDialogContent, NewDialogTitle } from 'components';
import { Link } from 'react-router-dom';

export default function CreateBulk({ title, refetch }) {
  const [file, setFile] = useState(null);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [formError, setFormError] = useState(true);
  const [attachment, setAttachment] = useState(null);
  const { userToken } = useSelector((state) => state.auth);

  const [errorsFile, setErrorsFile] = useState('');
  const [errorsCount, setErrorsCount] = useState(0);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const [formUpdate, { loading }] = useMutation(graph.create.query, {
    context: {
      serviceName: graph.create.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onChangeFile = ({
    target: {
      validity,
      files: [file],
    },
  }) => {
    if (validity.valid) {
      setAttachment(file);
      setFile(file);
    }
  };

  const onChange = ({ formData, errors }) => {
    setFormData(formData);
    setFormError(Boolean(errors.length > 0));
  };

  const onSubmit = async () => {
    try {
      const { data, errors } = await formUpdate({
        variables: {
          need_activation: 1,
          file: file ? file : undefined,
          send_sms: ['FOR_REGISTER_CODE'],
          cellphones: formData?.cellphones ? JSON.parse(formData?.cellphones) : undefined,
        },
      });
      if (!errors) {
        refetch();
        // onClose();
        const { messages, failed_users_file, failed_users_count } = data[graph.create.name];
        setErrorsFile(failed_users_file);
        setErrorsCount(failed_users_count);
        if (!isEmptyObject(data)) {
          messages.map((message) => toast.success(String(message)));
        }
      }
    } catch (error) {
      setFormData(formData);
    }
  };

  return (
    <>
      <Tooltip title={<FormattedMessage id={title} />}>
        <IconButton size="medium" color="warning" onClick={onOpen} disabled={loading} sx={{ bgcolor: 'action.hover' }}>
          <BackupRoundedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <NewDialog label="create" open={open} onClose={onClose}>
        <NewDialogTitle
          title={title}
          onClose={onClose}
          actions={
            <>
              <IconButton
                size="small"
                color="info"
                aria-label="close"
                onClick={onClose}
                sx={{ bgcolor: 'info.lighter' }}
              >
                <AttachFileRoundedIcon fontSize="small" />
              </IconButton>
            </>
          }
        />
        <NewDialogContent isPopup>
          <Stack p={1} flex={2} rowGap={1} bgcolor="background.paper">
            <input
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              style={{ display: 'none' }}
              id="file"
              name="file"
              multiple={false}
              type="file"
              onChange={onChangeFile}
            />
            <label htmlFor="file">
              <Stack
                minHeight={250}
                borderRadius={3}
                border="1px dashed"
                alignItems="center"
                justifyContent="center"
                borderColor="text.disabled"
                sx={{
                  transition: 'all 0.5s ease',
                  ':hover': { bgcolor: '#f1f1f1', transition: 'all 0.7s ease' },
                }}
              >
                <Typography color="text.secondary" fontSize={80}>
                  {loading ? <CircularProgress size={80} /> : <BackupRoundedIcon fontSize="inherit" />}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {attachment?.name || 'انتخاب فایل'}
                </Typography>
                <Typography variant="caption" color="text.disabled">
                  {attachment?.size ? `${(attachment.size / 1024).toFixed(2)} کیلوبایت` : ''}
                </Typography>
              </Stack>
            </label>
            {errorsCount > 0 && (
              <Alert
                severity="warning"
                // action={
                //   <Button
                //     size="small"
                //     target="_blank"
                //     color="inherit"
                //     href={errorsFile}
                //     rel="noopener noreferrer"
                //     download="گزارش-خطا-کاربران.xlsx"
                //   >
                //     دانلود گزارش خطا
                //   </Button>
                // }
              >
                {`تعداد ${errorsCount} ردیف با خطا روبرو شد!`}
              </Alert>
            )}
            <Form formData={formData} onChange={onChange} />
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            size="large"
            variant="contained"
            onClick={onSubmit}
            sx={{ minWidth: 80 }}
            disabled={loading || formError || (!formData?.cellphones?.length && !file)}
          >
            <FormattedMessage id="create" />
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
